import UserHistoryPagination from './UserHistoryPagination';

export default UserHistoryPagination;
